<template>
    <div :class="['parametric-flat', {'is-active': printIds.includes(flatData.id)}]">
        <div class="parametric-flat__status"
             @click="toggleFlatPrint">
            <IconCheckSmall class-name="icon-stroke icon_color_white" />
        </div>

        <div v-if="flatData.images?.length"
             class="parametric-flat__image">
            <FlatPlan ref="flatPlan"
                      :images="flatData.images"
                      :name="flatData.name"
                      :area="flatData.area"
                      :alt-text="flatData.name"
                      :image-zoom="Boolean(flatData.images?.length)"
                      :is-mobile="isMobile" />
        </div>

        <div class="parametric-flat__content"
             @click="toggleFlatPrint">
            <div class="parametric-flat__top">
                <div class="parametric-flat__top-info">
                    <span>{{ flatData.complex }}</span>
                    <a v-if="flatData.site"
                       :href="flatData.site"
                       target="_blank">
                        {{ flatData.site | clearLink }}
                    </a>
                </div>
                <div class="parametric-flat__top-name">
                    {{ flatData.name }}
                </div>
            </div>

            <div class="parametric-flat__props">
                <span v-if="flatData.area"
                      class="parametric-flat__props-value">{{ flatData.area }} м²</span>
                <span v-if="flatData.floor"
                      class="parametric-flat__props-value">{{ flatData.floor }} этаж</span>
                <span v-if="flatData.building"
                      class="parametric-flat__props-value">{{ flatData.building }} корпус</span>
                <span v-if="flatData.section"
                      class="parametric-flat__props-value">{{ flatData.section }} секция</span>
                <span v-if="flatData.completion"
                      class="parametric-flat__props-value">{{ flatData.completion }}</span>
                <span v-for="item in flatData.advantages"
                      :key="item"
                      class="parametric-flat__props-value">
                    {{ item }}
                </span>
            </div>

            <div class="parametric-flat__prices">
                <div class="parametric-flat__price">
                    <div class="parametric-flat__price-label">
                        Цена за кв.м
                    </div>
                    <div class="parametric-flat__price-value">
                        {{ flatData.priceArea | format }}&nbsp;тыс.&nbsp;руб.
                    </div>
                </div>
                <div class="parametric-flat__price">
                    <div class="parametric-flat__price-label">
                        Стоимость
                    </div>
                    <div v-if="flatData.priceOld"
                         class="parametric-flat__price-old">
                        {{ flatData.priceOld | format }} ₽
                    </div>
                    <div class="parametric-flat__price-value">
                        <template v-if="flatData.price">
                            {{ flatData.price | format }} ₽ <span v-if="flatData.sale">-{{ flatData.sale }}%</span>
                        </template>
                        <template v-else>
                            Цена по запросу
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconCheckSmall from '@/components/Icons/CheckSmall';
import FlatPlan from '@/components/Flat/Plan/Plan';
import {mapActions, mapGetters} from 'vuex';

/**
 * Компонент для вывода информации по помещению
 */
export default {
    name: 'ParametricFlat',

    components: {
        IconCheckSmall,
        FlatPlan
    },

    filters: {
        format: (val) => {
            return `${Math.floor(val)}`.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ');
        },

        clearLink: (url) => {
            // Удаляем "http://" или "https://" из начала строки
            url = url.replace(/^https?:\/\//i, '');

            // Удаляем завершающий символ "/", если он есть
            url = url.replace(/\/$/, '');

            return url;
        },
    },

    props: {
        /**
         * Данные помещения
         * id    "9DC0402A-979B-4CCB-81B8-87B4C5A3D1D2"
         * name    "2-комнатная евро № 286"
         * floor    "25"
         * section    "1"
         * building    "1"
         * stage    ""
         * complex    "Twelve"
         * complex_id    "E0AD032D-42E6-4A80-BBDA-B08E5FE621C1"
         * type    "flats"
         * image    "/storage/2023/04/13/e728383fffcc1ae03569844b546842756d7e1db2.svg"
         * pdf    false
         * price    18368500
         * discountedCost    0
         * area    42.5
         * similar_count    8
         */
        flatData: Object,
        isMobile: Boolean
    },

    computed: {
        ...mapGetters({
            printIds: 'parametric/GET_PRINT_FLATS_IDS' // Массив id-шников помещений для печати
        }),
    },

    methods: {
        ...mapActions('parametric', ['addFlatToPrint']),

        /**
         * Добавляет/удаляет помещение из печати
         */
        toggleFlatPrint() {
            this.addFlatToPrint(this.flatData);
        }
    }
};
</script>

<style lang="scss">
@import "ParametricFlat";
</style>
